export default __webpack_public_path__ + "static/media/vidsocialimpact2.a6df6a80.mp4";